

  <div class="bg-[#FCFCFC] ">
    <app-sidebar [class.open]="isMobileMenuOpen"  class="hidden md:block fixed z-30"></app-sidebar>
    <main>
      <app-topbar></app-topbar>
      <div class="py-6">
     <router-outlet></router-outlet>
     </div>
    </main>
  </div>
